import Container from '@anm/components/Container';
import { flexColumn, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const headerWrapperOnMobile = media.phone`
  padding: 0;
`;

export const HeaderWrapper = styled(Container)`
  width: 100%;
  margin-top: 20px;
  ${headerWrapperOnMobile};
`;

const mainOnMobile = media.phone`
  max-width: unset;
`;

export const Main = styled.div`
  ${flexColumn};
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  align-items: stretch;
  background-color: #fff;
  /* max-width: calc(100vw - 15px); TODO: check if we need this */
  min-height: calc(100vh - 116.5px);
  ${mainOnMobile};
`;
